/**
 * escribe aqui tus variables globales
 */

export const project_config = {
    MONITORING_TRACING: {
        GOOGLE_ANALYTICS: {
            ACTIVO: true,
            CODIGO: 'UA-99168958-5',
        },
        SENTRY: {
            ACTIVO: false,
        },
        HANDLE_ERROR:{
            CONSOLE_LOG: true
        }
    },
    SISTEMA: {
        TUTORIAL: {
            ACTIVE: false,
        },
        MENUS: {
            ITEMS_ICON: false,
            FLAT_ICONS: true,
        },
        URL: {
            PATHMENUSIMG: 'imagenes/iconos_sistemas/menus/portalAdmision/',
            PATHITEMSIMG: 'imagenes/iconos_sistemas/menus/items/portalAdmision/',
            PATHSTATIC: '/static/sistemas/portalAdmision/'           
        },
    },
};
